import decode from 'jwt-decode';
import _ from 'lodash';

import storageFactory from '../utils/storage-factory';

const AUTH_TOKEN = 'pmn_ink_token';
export const PREVIOUSLY_IN_INK = 'previously_logged_in_ink';
const localStore = storageFactory();

function isTokenValid() {
  // Checks if there is a saved token and it's still valid
  const token = getToken();
  return !!token && !isTokenExpired(token);
}

function isTokenExpired(token) {
  const decoded = decode(token);
  return decoded.exp < Date.now() / 1000; // Checking if token is expired.
}

function getTokenExpiry() {
  const token = getToken();

  if (!token) {
    return 0;
  }

  const decodedToken = decode(token);
  return decodedToken.exp;
}

function setToken(token) {
  if (!token) {
    return;
  }
  localStore.setItem(AUTH_TOKEN, token)
}

function getToken() {
  return localStore.getItem(AUTH_TOKEN);
}

function removeToken() {
  localStore.removeItem(AUTH_TOKEN);
}

function getProfile() {
  return decode(getToken());
}

// Resolves a human-readable sender name for audit surfaces (e.g. the #alerts
// Slack message). Reads the live token at call time rather than at mount, and
// guards against a missing/invalid token (decode throws on a null token). Falls
// back through the AuthContext user captured at app load, then nickname/email,
// so a renewed token minted without the `name` claim never yields "undefined".
function getDisplayName(fallbackUser) {
  let profile = {};

  try {
    profile = getProfile() || {};
  } catch (e) {
    profile = {};
  }

  return (
    profile.name
    || fallbackUser?.name
    || profile.nickname
    || profile.email
    || 'Unknown user'
  );
}

function withAuthHeader(headers) {
  if (isTokenValid()) {
    const headers_ = headers ? _.cloneDeep(headers) : {};
    headers_['Authorization'] = `Bearer ${getToken()}`;
    return headers_;
  }
  return headers
}

export {
  isTokenValid,
  getTokenExpiry,
  setToken,
  getToken,
  removeToken,
  getProfile,
  getDisplayName,
  withAuthHeader,
};
